import { Component, Input, ChangeDetectionStrategy } from "@angular/core";

@Component({
  selector: "claas-app-header",
  imports: [],
  templateUrl: "./app-header.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./app-header.scss",
})
export class AppHeaderComponent {
  @Input() imageUrl?: string;
}
